import React, { useContext, useState } from 'react'
import { Trans, t } from '@lingui/macro'

import { Drawer } from '../../../components/common/page/drawer/Drawer'
import DrawerItem from '../../../components/common/page/drawer/DrawerItem'
import Textarea from '../../../components/common/form/textarea/Textarea'
import GeneralRemoveModal from '../../../components/common/general-remove-modal/GeneralRemoveModal'
import { ButtonDanger } from 'front-end/src/components'
import IconTrash from '../../../components/common/icon/IconTrash'
import Input from '../../../components/common/form/input/Input'
import { staticLinks } from '../../../../../shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { ManageCertificationPageContext } from './ManageCertificationPage'
import { SelectMonthsOfValidity } from '../components/SelectMonthsOfValidity'
import {
  usePatchCertificationMutation,
  useDeleteCertificationMutation
} from './CertificationsDrawer.codegen'

export interface ICertificationsDrawerProps {
  show?: boolean
  onHide: () => void
  onUpdate: () => void
}

export const CertificationsDrawer: React.FC<ICertificationsDrawerProps> = (
  props
) => {
  const { certification } = useContext(ManageCertificationPageContext)
  const [removalModalVisible, showRemovalModal] = useState(false)
  const [patchFn] = usePatchCertificationMutation()
  const [deleteFn] = useDeleteCertificationMutation()

  return (
    <>
      <Drawer
        className="DashboardsDrawer"
        title={t`Settings`}
        show={props.show}
        onHide={props.onHide}
      >
        <DrawerItem label="Name" className="full-width">
          <Input
            light
            defaultValue={certification.name}
            debouncedOnChange={(value) => {
              patchFn({
                variables: {
                  id: certification.id,
                  data: {
                    name: value
                  }
                }
              })
            }}
          />
        </DrawerItem>

        <DrawerItem label={t`Description`} className="full-width">
          <Textarea
            // @ts-expect-error
            value={certification.description}
            rows={5}
            debouncedOnChange={(value) => {
              patchFn({
                variables: {
                  id: certification.id,
                  data: {
                    description: value
                  }
                }
              })
            }}
          />
        </DrawerItem>
        <DrawerItem label={t`Expires after`} className="full-width">
          <SelectMonthsOfValidity
            disabled={!!certification.locked_at}
            value={certification.months_of_validity}
            onChange={(value) => {
              patchFn({
                variables: {
                  id: certification.id,
                  data: {
                    months_of_validity: value
                  }
                }
              })
            }}
          />
        </DrawerItem>

        <DrawerItem label={t`Archive this certification`}>
          <GeneralRemoveModal
            show={removalModalVisible}
            actionName={'archive'}
            header={t`Archive certification`}
            entityName="certification"
            confirmButton={t`Archive`}
            onDeleted={() => showRemovalModal(false)}
            onCanceled={() => showRemovalModal(false)}
            operation={async () => {
              await deleteFn({
                variables: {
                  id: certification.id
                }
              })
              navigateTo(staticLinks.certifications)
            }}
          />

          <ButtonDanger
            onClick={async () => {
              showRemovalModal(true)
            }}
            leftIcon={<IconTrash />}
          >
            <Trans>Archive</Trans>
          </ButtonDanger>
        </DrawerItem>
      </Drawer>
    </>
  )
}
